const data = {
  title: "Floor 2-6",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 3,
  tilesHeight: 24,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 2,
      y: 23,
    },
    {
      type: "WATER_PICKUP",
      x: 2,
      y: 4,
    },
    {
      type: "ENEMY_SPAWN",
      x: 3,
      y: 7,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "WATER",
      x: 2,
      y: 6,
    },
    {
      type: "WATER",
      x: 3,
      y: 6,
    },
    {
      type: "WATER",
      x: 1,
      y: 8,
    },
    {
      type: "WATER",
      x: 2,
      y: 8,
    },
    {
      type: "WATER",
      x: 2,
      y: 9,
    },
    {
      type: "WATER",
      x: 1,
      y: 9,
    },
    {
      type: "WATER",
      x: 1,
      y: 10,
    },
    {
      type: "WATER",
      x: 2,
      y: 10,
    },
    {
      type: "WATER",
      x: 1,
      y: 12,
    },
    {
      type: "WATER",
      x: 2,
      y: 12,
    },
    {
      type: "WATER",
      x: 3,
      y: 12,
    },
    {
      type: "WATER",
      x: 2,
      y: 14,
    },
    {
      type: "WATER",
      x: 2,
      y: 15,
    },
    {
      type: "WATER",
      x: 2,
      y: 16,
    },
    {
      type: "WATER",
      x: 3,
      y: 16,
    },
    {
      type: "WATER",
      x: 3,
      y: 15,
    },
    {
      type: "WATER",
      x: 3,
      y: 14,
    },
    {
      type: "WATER",
      x: 1,
      y: 18,
    },
    {
      type: "WATER",
      x: 3,
      y: 18,
    },
    {
      type: "WATER",
      x: 3,
      y: 19,
    },
    {
      type: "WATER",
      x: 1,
      y: 19,
    },
    {
      type: "WATER",
      x: 1,
      y: 20,
    },
    {
      type: "WATER",
      x: 2,
      y: 20,
    },
    {
      type: "WATER",
      x: 3,
      y: 20,
    },
    {
      type: "WATER",
      x: 1,
      y: 22,
    },
    {
      type: "WATER",
      x: 2,
      y: 22,
    },
    {
      type: "WATER",
      x: 3,
      y: 22,
    },
    {
      type: "WATER",
      x: 1,
      y: 23,
    },
    {
      type: "WATER",
      x: 3,
      y: 23,
    },
    {
      type: "WATER",
      x: 3,
      y: 24,
    },
    {
      type: "WATER",
      x: 2,
      y: 24,
    },
    {
      type: "WATER",
      x: 1,
      y: 24,
    },
    {
      type: "ENEMY_SPAWN",
      x: 3,
      y: 9,
      direction: "DOWN",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 3,
      y: 11,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "WALL",
      x: 3,
      y: 8,
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 13,
      direction: "RIGHT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 17,
      direction: "RIGHT",
      enemyType: "ENEMY",
    },
    {
      type: "WALL",
      x: 1,
      y: 14,
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 15,
      direction: "DOWN",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 2,
      y: 19,
      direction: "UP",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 3,
      y: 21,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
  ],
};

export default data;
